const Switch = {
  baseStyle: {
    track: {
      _focus: { boxShadow: "none" },
    },
  },
}

export default Switch
